export default "__VITE_ASSET__B0kRff3z__"